export const filterObject = {
  types: [],
  manufacturers: [],
  models: [],
};
